<template>
  <Modal
    :id="'cmp-booking-booking-booking_sidewindow-add_travel'"
    :loadingFlag="loadingFlag"
    @cancelled="onCancelClick"
  >
    <template slot="header"
      >{{ mode }} {{ $dft.snakeCaseToWords(parent) }}</template
    >
    <template slot="body">
      <v-layout row wrap>
        <v-flex md6 class="dt-modal--column first-half">
          <div class="form-group">
            <Dropdown
              class="dt-dropdown m2"
              :options="travelTypes"
              :selected="selectedType"
              box
              :placeholder="$t('travel_type')"
              v-on:selectedChange="(e) => onDropdownChange('travelType', e)"
              :listHeight="95"
            ></Dropdown>
          </div>
        </v-flex>
        <v-flex md3 class="dt-modal--column second-half relative-block" style="padding-top: 1px;">
          <div class="form-group">
            <!-- <TextField
              :id="'flightNo'"
              v-bind="textFieldConfig"
              class="m1"
              v-model="flightNo"
              isModel
              :placeholder="'Flight #'"
              @validated="onValidation"
            ></TextField> -->

            <TextField
              class="m1"
              :id="'flightNo'"
              v-model="flightNo"
              isModel
              :placeholder="$t('flight')+' #'"
              @validated="onValidation"
            />
          </div>

          <button class="dt-button v5 s8 btn-absolute" style="font-size:10px;right: 1px;" @click="onGetFlightInfo">
            {{$t('get_flight_info')}}
          </button>
        </v-flex>
        <v-flex md3 style="padding-left: 10px;">
          <div class="form-group" v-if="scheduledFlightsOptions.length > 1">
            <Dropdown
              class="dt-dropdown m2"
              :options="scheduledFlightsOptions"
              :selected="selectedFlight"
              box
              :placeholder="$t('choose_flight')"
              v-on:selectedChange="(e) => onDropdownChange('selectFlight', e)"
              :listHeight="95"
            ></Dropdown>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md6 class="dt-modal--column first-half">
          <div class="dt-modal--subtitle"> {{$t('departure')}} </div>
          <div class="form-group">
            <v-layout row wrap>
              <v-flex md7 style="padding-right: 5px">

                <TextField
                  class="m1"
                  :id="'dateOrigin'"
                  :value="travel.dateOrigin"
                  :placeholder="$t('date')"
                  :label="$t('dateOrigin')"
                  :type="'date'"
                  @valuechanged="onTextFieldValueChange"
                  @validated="onValidation"
                />
              </v-flex>
              <v-flex md5 style="padding-left: 5px">
                <TextField
                  class="m1"
                  :id="'timeOrigin'"
                  autocomplete="off"
                  :value="travel.timeOrigin"
                  :placeholder="$t('time')"
                  :label="$t('timeOrigin')"
                  :type="'time'"
                  @valuechanged="onTextFieldValueChange"
                  @validated="onValidation"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md7 style="padding-right: 5px">
                <TextField
                  class="m1"
                  :id="'origin'"
                  :value="travel.origin"
                  :placeholder="$t('origin')"
                  :label="$t('origin')"
                  @valuechanged="onTextFieldValueChange"
                  @validated="onValidation"
                />
              </v-flex>
              <v-flex md5 style="padding-left: 5px">
                <TextField
                  class="m1"
                  :id="'originCode'"
                  :value="travel.originCode"
                  :placeholder="$t('origin_code')"
                  :label="$t('originCode')"
                  @valuechanged="onTextFieldValueChange"
                  @validated="onValidation"
                />
              </v-flex>
            </v-layout>
          </div>
          <div class="dt-modal--subtitle"> {{$t('arrival')}} </div>
          <div class="form-group">
            <v-layout row wrap>
              <v-flex md7 style="padding-right: 5px">
                <TextField
                  class="m1"
                  :id="'dateArrival'"
                  :value="travel.dateArrival"
                  :placeholder="$t('date')"
                  :label="$t('dateArrival')"
                  :type="'date'"
                  @valuechanged="onTextFieldValueChange"
                  @validated="onValidation"
                />
              </v-flex>
              <v-flex md5 style="padding-left: 5px">
                <v-layout row wrap>
                  <v-flex md12>
                    <TextField
                      class="m1"
                      :id="'timeArrival'"
                      :value="travel.timeArrival"
                      autocomplete="off"
                      :placeholder="$t('time')"
                      :label="$t('timeArrival')"
                      :type="'time'"
                      @valuechanged="onTextFieldValueChange"
                      @validated="onValidation"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md7 style="padding-right: 5px">
                <v-layout row wrap>
                  <v-flex md12>
                    <TextField
                      class="m1"
                      :id="'arrival'"
                      :value="travel.arrival"
                      :placeholder="$t('arrival')"
                      :label="$t('arrival')"
                      @valuechanged="onTextFieldValueChange"
                      @validated="onValidation"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md5 style="padding-left: 5px">
                <v-layout row wrap>
                  <v-flex md12>
                    <TextField
                      class="m1"
                      :id="'arrivalCode'"
                      :value="travel.arrivalCode"
                      :placeholder="$t('code')"
                      :label="$t('arrivalCode')"
                      @valuechanged="onTextFieldValueChange"
                      @validated="onValidation"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-flex md6 class="dt-modal--column second-half">
          <div class="dt-modal--subtitle"> {{$t('contacts')}} </div>
          <div class="con-rel-container hoverFC2">
            <NTable
              class="dbox1"
              id="booking-booking-booking_sidewindow-add_travel"
              :config="tableConfig"
              :headers="contactsHeaders"
              :items="contactRelations"
            >
              <template v-slot:item="{ item, tdcon }">
                <tr>
                  <td v-bind="tdcon('name')">
                    <div class="txtov">{{ getName(item) }}</div>
                  </td>
                  <td v-bind="tdcon('booking_code')">
                    <TextField2
                      :id="'booking_code'"
                      :showLabel="false"
                      :placeholder="$t('booking_code_string')"
                      :value="contactRel.bookingCodes[item.contact_id]"
                      @keyup="(e) => bookingCodeChange(e, item)"
                    />
                  </td>
                  <td v-bind="tdcon('e-ticket')">
                    <TextField2
                      :id="'e-ticket'"
                      :showLabel="false"
                      :placeholder="$t('e_ticket')"
                      :value="contactRel.eTickets[item.contact_id]"
                      @keyup="(e) => eTicketsChange(e, item)"
                    />
                  </td>
                  <td v-bind="tdcon('options')">
                    <div class="dt-checkbox v2 s1">
                      <input
                        type="checkbox"
                        :name="item.contact_id + '_checkbox'"
                        :id="item.contact_id + '_checkbox'"
                        :checked="selectedContactRelations.has(item.contact_id)"
                        @click="(e) => onCheckboxChange(e, item)"
                      />
                      <div class="checkmark"></div>
                    </div>
                  </td>
                </tr>
              </template>
            </NTable>
          </div>
          <v-layout
            row
            wrap
            style="margin-top: 10px; justify-content: flex-end"
          >
            <div class="selection-checkbox">
              <label class="checkbox-label">
                {{$t('select_all')}}
              </label>
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  :name="'select_all_checkbox'"
                  :id="'select_all_checkbox'"
                  :checked="
                    selectedContactRelations.size == contactRelations.length
                  "
                  @click="(e) => onSelectAllNone(e)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
      <ExpandBox
        :chevronIcon="chevronIcon"
        :title="expanded ? $t('show_less_information') : $t('show_more_information')"
        @expanded="onExpanded"
      >
        <template v-slot:body>
          <v-layout>
            <v-flex md6 class="dt-modal--column first-half">
              <div class="dt-modal--subtitle"> {{$t('travel_details')}} </div>
              <div class="form-group">
                <v-layout row wrap>
                  <v-flex md12>
                    <TextField
                      class="m1"
                      :id="'carrier'"
                      :value="travel.carrier"
                      :placeholder="$t('carrier')"
                      :label="$t('carrier')"
                      @valuechanged="onTextFieldValueChange"
                      @validated="onValidation"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md12>
                    <TextField
                      class="m1"
                      :id="'travelNo'"
                      :value="travel.travelNo"
                      :placeholder="$t('travel')+' #'"
                      :label="$t('carrier')"
                      @valuechanged="onTextFieldValueChange"
                      @validated="onValidation"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md12>
                    <TextField
                      class="m1"
                      textarea
                      :height="135"
                      :id="'notes'"
                      :value="travel.notes"
                      :placeholder="$t('notes')"
                      :label="$t('notes')"
                      @valuechanged="onTextFieldValueChange"
                      @validated="onValidation"
                    />
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex md6 class="dt-modal--column second-half">
              <div class="dt-modal--subtitle"> {{$t('booking_details')}} </div>
              <div class="form-group">
                <TextField
                  class="m1"
                  :id="'travelCosts'"
                  :value="travel.travelCosts"
                  :placeholder="$t('travel_costs')"
                  :label="$t('travelCosts')"
                  @valuechanged="onTextFieldValueChange"
                  @validated="onValidation"
                />
                <TextField
                  class="m1"
                  :id="'travelAgent'"
                  :value="travel.travelAgent"
                  :placeholder="$t('travel_agent')"
                  :label="$t('travelAgent')"
                  @valuechanged="onTextFieldValueChange"
                  @validated="onValidation"
                />

                <Dropdown
                  class="dt-dropdown m2"
                  :options="usersTV"
                  :selected="usersTV.find((e) => e.value == selectedUser)"
                  :placeholder="$t('user')"
                  box
                  v-on:selectedChange="(e) => onDropdownChange('user', e)"
                  :listHeight="95"
                ></Dropdown>
                <TextField
                  class="m1"
                  :id="'date'"
                  :value="travel.date"
                  :placeholder="$t('date')"
                  :label="$t('date')"
                  :type="'date'"
                  @valuechanged="onTextFieldValueChange"
                  @validated="onValidation"
                />
              </div>
            </v-flex>
          </v-layout>
        </template>
      </ExpandBox>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick"> {{$t('cancel')}} </button>
      <button class="dt-button v1 s6" @click="onAddTravelClick"> {{$t('ok')}} </button>
    </template>
  </Modal>
</template>

<script>
import {
  createTravel,
  stringToDateObj,
  stringToFlightObj,
  getOnlyDateFromString,
  getOnlyTimeFromString,
  processFlightResponse,
  createTravelFromResponse,
} from "../../models/travel.model";
import { BookingService } from "../../services/booking-service";
import { addRemoveSet } from "../../../../utility";
import DatePicker from "@plugins/text-field/date-picker";
import {
  NotificationService,
  showError,
} from "../../../../dt-plugins/notification/notification.service";
import Modal from "../../../../dt-plugins/modal/modal";
import InputField from "../../../../plugins/text-field/input-field";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import NTable from "@/plugins/datatable/datatable";
import ExpandBox from "@plugins/expandable-box/expand-box";
import { EventHooks } from "../../../../plugins/text-field";
import { addDays } from "date-fns";
import { getDefaultDateString } from "../../../../utility/calendar";
import { getName } from "../../../contacts/models/contact-details.model";
import { createTV } from "../../../../models/text-value.model";

export default {
  components: {
    DatePicker,
    Modal,
    NTable,
    InputField,
    ExpandBox,
  },
  props: {
    calendarDate: {
      type: String,
    },
    booking: {
      type: Object,
    },
    // contactRelations: {
    //   type: Array,
    // },
    users: {
      type: Array,
    },
    user: {
      type: Object,
    },
  },
  data: function () {
    return {
      selectedTravel: null,

      dateOriginMenu: false,
      timeOriginMenu: false,
      dateArrivalMenu: false,
      timeArrivalMenu: false,
      dateMenu: false,

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
      validationResult: {},
      flightNo: "",
      travel: createTravel(),
      selectedType: { text: "By Air", value: "by_air" },
      travelTypes: [
        { text: "By Air", value: "by_air" },
        { text: "By Train", value: "by_train" },
        { text: "By Car", value: "by_car" },
        { text: "Tour Bus", value: "tourbus" },
        { text: "Boat", value: "boat" },
      ],

      selectedUser: "",

      contactRel: {
        bookingCodes: {},
        eTickets: {},
      },
      selectedContactRelations: new Set(),
      text: `Please provide a valid Flight number`,

      datePickerConfig: {
        controlType: "textfield",
        showImmediate: false,
      },
      tableConfig: createNTableConfig({
        headerStyle: 2,
        rowHeight: 28,
        fullHeight: true,
        footer: false,
      }),

      chevronIcon: true,
      expanded: "",
      flightResponse: {},
      scheduledFlights: [],
      scheduledFlightsOptions: [],
      selectedFlight: {},
      selectedScheduledFlightIndex: 0,
    };
  },
  mounted: async function () {
    try {
      if (!this.calendarDateId) {
        throw Error("Pass a Valid Calendar Date ID as a Route Param");
      }
      if (!this.$route.query.modal) {
        throw Error("Modal must be passed as a Route Query");
      }
      if (!this.$route.query.mode) {
        throw Error('Pass a valid mode like "edit" or "add"');
      }
      if (this.$route.query.mode === "edit" && !this.$route.query.travel_id) {
        throw Error("Pass a valid traveld_id in the Route Query");
      }
    } catch (error) {
      NotificationService.showNotification({
        text: error.message,
        timeout: 5000,
        color: "error",
      });
      this.onCancelClick();
    }

    if (this.mode === "edit") {
      BookingService.findTravelDescription({
        calendarDateId: this.calendarDateId,
        travelId: this.travel_id,
      }).then((res) => {
        console.log("Fetching Selected Travel");
        this.selectedTravel = res.data;
      });
    } else if (this.mode == "add") {
      const { start_date, end_date } = this.booking.cdate;
      // console.log(this.modal, this.mode, {start_date, end_date});
      if (this.modal == "travel_after") {
        this.travel.dateOrigin = getDefaultDateString(addDays(end_date, 1));
        this.travel.dateArrival = getDefaultDateString(addDays(end_date, 1));
      } else if (this.modal == "travel_before") {
        this.travel.dateOrigin = start_date;
        this.travel.dateArrival = start_date;
      }

      // Fetch the basic Data

      this.selectedTravel = await BookingService.findAddTravelData({
        calendarDateId: this.calendarDateId,
        after_gig_flag: this.afterGigFlag,
      }).then((res) => res.data);

      console.log({ "this.selectedTravel": this.selectedTravel });

      // Selecting All Contacts on Add Modal
      this.selectAll();
    }
  },
  watch: {
    mode: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.resetData();
      },
    },
    // user: {
    //   immediate: true,
    //   handler: function (newValue, oldValue) {
    //     if (!newValue) {
    //       return;
    //     }
    //     if (this.mode === "add") {
    //       // this.selectedUser = {
    //       //   text: newValue?.user_name,
    //       //   value: newValue?.user_id,
    //       // };
    //     }
    //   },
    // },
    selectedTravel: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (newVal && newVal.travel) {
          console.log({ selectedTravel: newVal });
          this.travel = createTravelFromResponse(newVal.travel);
          this.selectedType = this.travelTypes.find(
            (e) => e.value == this.travel.type
          );
          //Settings Default Selected User
          this.selectedUser =
            newVal?.user?.user_id || this.$store.getters.account.user.user_id;

          this.selectedContactRelations = new Set(
            newVal.travel_contacts
              .filter((e) => e.contact_relation_id)
              .map((e) => {
                console.log({ "this.contactRel": this.contactRel, e });
                this.contactRel.bookingCodes[e.contact_id] = e.txt01;
                this.contactRel.eTickets[e.contact_id] = e.txt02;
                return e.contact_id;
              })
          );
        }
      },
    },
    selectedFlight:{
      immediate: true,
      handler: function (newVal, oldVal) {
        console.log('mdsir travel: ', newVal);
        if(this.flightResponse?.data?.content && newVal?.value){
          this.travel = {
            ...this.travel,
            ...processFlightResponse(this.flightResponse, newVal),
          };
        }
      }
    }
  },
  computed: {
    contactRelations() {
      return this.selectedTravel?.travel_contacts || [];
    },
    afterGigFlag() {
      return this.parent === "travel_after" ? "1" : "";
    },
    usersTV: function () {
      return createTV(this.selectedTravel?.users, "user_name", "user_id");
    },
    parent: function () {
      return this.$route.query.modal;
    },
    modal: function () {
      return this.$route.query.modal;
    },
    mode: function () {
      if (this.$route.query.mode === "edit") {
        return "edit";
      } else {
        return "add";
      }
    },
    travel_id: function () {
      return this.$route.query.travel_id;
    },
    calendarDateId: function () {
      return this.$route.params.calendar_date_id;
    },
    // contactsHeaders: function() {
    //   return [
    //     { text: "Name", value: "name" },
    //     { text: "Booking Code", value: "booking_code" },
    //     { text: "E-Ticket", value: "etickets" },
    //     { text: "", value: "options" }
    //   ];
    // },
    contactsHeaders: function () {
      return [
        createTableHeader("name"),
        createTableHeader("booking_code", { text: "Booking Code" }),
        createTableHeader("etickets", {
          text: "E-Ticket",
          mw: 90,
        }),
        createTableHeader("options", { text: false, mw: 30, ta: "center" }),
      ];
    },
    loadingFlag: function () {
      if (this.mode === "edit") {
        return this.selectedTravel ? false : true;
      } else {
        return false;
      }
    },
  },
  methods: {
    getName: getName,
    resetData: function () {
      this.dateOriginMenu = false;
      this.timeOriginMenu = false;
      this.dateArrivalMenu = false;
      this.timeArrivalMenu = false;
      this.dateMenu = false;
      this.validationResult = {};
      this.flightNo = "";
      this.travel = createTravel();
      this.selectedType = { text: "By Air", value: "by_air" };
      this.selectedUser = "";
      this.contactRel = { bookingCodes: {}, eTickets: {} };
      this.selectedContactRelations = new Set();
      this.text = `Please provide a valid Flight number`;
    },
    onGetFlightInfo: function () {
      try {
        const flightObj = stringToFlightObj(this.flightNo);

        // console.log(stringToDateObj(this.calendarDate));

        BookingService.findFlightInfo({
          ...flightObj,
          ...stringToDateObj(this.travel.dateOrigin),
        }).then((res) => {
          const { data } = res;
          if (data.is_success) {
            if (res.data.content?.scheduledFlights?.length > 0) {
              this.flightResponse = res;
              this.scheduledFlights = res.data.content?.scheduledFlights;
              this.scheduledFlightsOptions = this.scheduledFlights.map((flight, value) => ({value: flight.referenceCode, text: `${flight.departureAirportFsCode} -> ${flight.arrivalAirportFsCode}`}));
              this.selectedFlight = this.scheduledFlightsOptions.length == 1 ? this.scheduledFlightsOptions[0] : {};
                // this.travel = {
                //   ...this.travel,
                //   ...processFlightResponse(res, this.selectedScheduledFlightIndex),
                // };
              
            } else {
              showError(this.$t("unavailable_info_for_flight_no"));
            }
          } else {
            showError(this.$t("connection_failed"));
          }
        });
      } catch (e) {
        if (e.message == "INVALID_FLIGHT_NUMBER") {
          showError("Please provide a valid flight number");
        }
      }
    },
    onTextFieldValueChange: function (name, value) {
      this.travel[name] = value;
      // console.log({ name, value });
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onDropdownChange: function (name, event) {
      switch (name) {
        case "travelType": {
          this.selectedType = event;
          break;
        }
        case "user": {
          this.selectedUser = event.value;
          break;
        }
        case "selectFlight": {
          this.selectedFlight = event;
          break;
        }
      }
    },
    onSelectNone: function (event) {
      this.selectedContactRelations = new Set();
    },
    onSelectAll: function (event) {
      this.selectedContactRelations = new Set(
        this.contactRelations.map((e) => e.contact_id)
      );
    },
    selectAll() {
      this.selectedContactRelations = new Set(
        this.contactRelations.map((e) => e.contact_id)
      );
    },
    onAddTravelClick: function (event) {
      const contacts = Array.from(this.selectedContactRelations);
      const fileKeys = contacts.map(
        (e) => this.contactRel.bookingCodes[e] || " "
      );
      const eTickets = contacts.map((e) => this.contactRel.eTickets[e] || " ");

      this.travel.contacts = contacts.join(",");
      this.travel.fileKeys = fileKeys.join(",");
      this.travel.eTickets = eTickets.join(",");

      this.travel.staffId = this.selectedUser;
      this.travel.type = this.selectedType && this.selectedType.value;

      if (this.parent === "travel_after") {
        this.travel.afterGigFlag = "1";
        this.travel.calendar_date_id_out = this.calendarDateId;
      } else {
        this.travel.calendar_date_id = this.calendarDateId;
      }

      this.$emit("submit", {
        mode: this.mode,
        travel: this.travel,
      });
    },
    onCancelClick: function (event) {
      this.$emit("cancelled", true);
    },
    onCheckboxChange: function (event, contactRelation) {
      this.selectedContactRelations = addRemoveSet(
        event.target.checked,
        this.selectedContactRelations,
        contactRelation.contact_id
      );
    },
    onSelectAllNone: function (event) {
      const checked = event.target.checked;

      if (checked) {
        this.selectedContactRelations = new Set(
          this.contactRelations.map(
            (contactRelation) => contactRelation.contact_id
          )
        );
      } else {
        this.selectedContactRelations = new Set();
      }
    },

    bookingCodeChange: function ({ name, value }, item) {
      // console.log({ name, value }, item);
      this.contactRel.bookingCodes[item.contact_id] = value;
    },
    eTicketsChange: function ({ name, value }, item) {
      // console.log({ name, value }, item);
      this.contactRel.eTickets[item.contact_id] = value;
    },
    onExpanded: function (e) {
      // console.log("dddddd ", e);
      this.expanded = e;
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
// .dt-modal {
//   padding: 40px 10px;
// }

.cmp-booking-booking-booking_sidewindow-add_travel {
  .con-rel-container {
    height: 230px;
    display: flex;
    flex-direction: column;

    .dt-ntable {
      background: var(--bc-35);

      // td:nth-child(3),
      // th:nth-child(3) {
      //   width: 90px !important;
      //   max-width: 90px !important;
      // }
      // td:nth-child(4),
      // th:nth-child(4) {
      //   width: 30px !important;
      //   max-width: 30px !important;
      // }

      border-radius: 5px;
      border-collapse: separate;
    }
  }

  .dt-modal--body {
    .selection-checkbox {
      margin-top: 5px;
      margin-right: 10px;
      display: flex;

      .checkbox-label {
        color: var(--text-secondary);
        margin: 0px 10px;
      }
      .dt-checkbox {
        margin-top: 2px;
      }
    }
  }

  .travel-details {
    .dt-form-label {
      max-width: 19.333333%;
    }
  }

  .flightno-bar {
    // border: 1px solid var(--sprt-5);
    margin: 0px !important;
    div {
      padding: 0px;
    }
    .dt-button {
      padding: 4px;
      margin: 0px;
    }
    input#flightNo {
      margin-left: 0px;
    }
    .flight-no-label,
    input#flightNo {
      margin-top: 4px;
    }
  }

  .cr-name,
  .cr-select {
    padding-top: 20px !important;
  }

  .select-cr {
    margin-top: 5px;
    margin-left: 5px;

    .dt-checkbox-input {
      left: 0px;
    }
  }

  .contact-relations {
    height: 318px;
  }

  .dt-textarea.notes {
    height: 95px;
  }

  // .dt-input-box--container {
  //   margin-left: 0 !important;
  // }

  .dt-modal-options {
    // margin-top: 10px;
  }

  .form-group {
    // padding: 10px;

    .dt-input-box {
      // margin: 5px 0px;
    }

    .group-input {
      // margin: 10px 0px;
      // text-align: left;
    }
  }

  .relative-block {
    position: relative;

    .input-container {
      input {
        width: calc(100% - 80px) !important;
      }
    }
  }
  .btn-absolute {
    position: absolute;
    right: 10px;
    top: 22px;
  }

  .expnad-box {
    margin-top: 15px;
    // position: relative;
    // top: 60px;
    .expand-box-header {
      border-bottom-color: transparent;
      .expand-icon {
        display: none;
      }

      .expand-box-header--title {
        display: flex;
        border-right-color: transparent;
        font-weight: 400 !important;
        color: var(--bc-accent5);
        padding-left: 0;
        // padding-left: 30px;
        position: relative;

        // &:before {
        //   content: "";
        //   position: absolute;
        //   left: 0px;
        //   top: 0px;
        //   width: 25px;
        //   height: 25px;
        //   // background: url("static/icons/arrows/chevron-down.svg");
        // }
      }
    }
  }
}
</style>
